"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListContainer = exports.Label = exports.InputControl = exports.DropdownMenuTrigger = exports.DropdownMenuItem = exports.DropdownMenuContent = exports.Container = exports.Arrow = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../../../utils");
var DropdownMenu = _interopRequireWildcard(require("@radix-ui/react-dropdown-menu"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Container = exports.Container = _styledComponents["default"].div.withConfig({
  displayName: "Selectstyle__Container",
  componentId: "sc-yhisnp-0"
})({
  position: 'relative',
  width: '100%'
});
var Label = exports.Label = _styledComponents["default"].label.withConfig({
  displayName: "Selectstyle__Label",
  componentId: "sc-yhisnp-1"
})(function (_ref) {
  var error = _ref.error,
    theme = _ref.theme;
  return _objectSpread({
    display: 'inline-block',
    color: error ? theme.color.feedback.error : theme.color.neutral['02'],
    marginBottom: theme.spacing.inline['5xs']
  }, (0, _utils.getTextStyle)({
    theme: theme,
    variant: 'body02-sm',
    margin: false
  }));
});
var DropdownMenuTrigger = exports.DropdownMenuTrigger = (0, _styledComponents["default"])(DropdownMenu.Trigger).withConfig({
  displayName: "Selectstyle__DropdownMenuTrigger",
  componentId: "sc-yhisnp-2"
})(function (_ref2) {
  var open = _ref2.open,
    theme = _ref2.theme;
  return _objectSpread(_objectSpread({
    transition: '0.3s border, 0.3s color',
    boxSizing: 'border-box',
    border: '1px solid',
    borderColor: open ? theme.color.brandPrimary.light : theme.color.neutral['04'],
    borderRadius: theme.border.radius['3xs'],
    background: theme.color.neutral['08'],
    height: theme.spacing.inline['5xl'],
    outline: 'none',
    color: open ? theme.color.brandPrimary.light : theme.color.neutral['02'],
    paddingLeft: theme.spacing.inline['4xs'],
    paddingRight: theme.spacing.inline.xl,
    whiteSpace: 'nowrap',
    width: '100%',
    overflow: 'hidden',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    position: 'relative'
  }, (0, _utils.getTextStyle)({
    theme: theme,
    variant: 'body02-sm',
    margin: false
  })), {}, {
    lineHeight: theme.spacing.inline['5xl'],
    ':disabled': {
      color: theme.color.neutral['05'],
      cursor: 'default'
    },
    '&.error': {
      borderColor: theme.color.feedback.error,
      color: theme.color.feedback.error,
      svg: {
        color: theme.color.feedback.error
      }
    }
  });
});
var InputControl = exports.InputControl = _styledComponents["default"].input.withConfig({
  displayName: "Selectstyle__InputControl",
  componentId: "sc-yhisnp-3"
})({
  cursor: 'pointer',
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  margin: 0,
  padding: 0,
  border: 0,
  ':disabled': {
    cursor: 'default'
  }
});
var Arrow = exports.Arrow = _styledComponents["default"].svg.withConfig({
  displayName: "Selectstyle__Arrow",
  componentId: "sc-yhisnp-4"
})(function (_ref3) {
  var disabled = _ref3.disabled,
    _ref3$theme = _ref3.theme,
    spacing = _ref3$theme.spacing,
    color = _ref3$theme.color;
  return {
    display: 'block',
    position: 'absolute',
    top: 0,
    right: 0,
    color: disabled ? color.neutral['05'] : color.brandPrimary.light,
    paddingRight: spacing.inline['4xs'],
    width: spacing.inline.xs,
    height: '100%'
  };
});
var ListContainer = exports.ListContainer = _styledComponents["default"].div.withConfig({
  displayName: "Selectstyle__ListContainer",
  componentId: "sc-yhisnp-5"
})({
  position: 'relative',
  width: '100%',
  height: 0
});
var DropdownMenuContent = exports.DropdownMenuContent = (0, _styledComponents["default"])(DropdownMenu.Content).withConfig({
  displayName: "Selectstyle__DropdownMenuContent",
  componentId: "sc-yhisnp-6"
})(function (_ref4) {
  var color = _ref4.theme.color;
  return {
    background: color.neutral['08'],
    boxSizing: 'border-box',
    position: 'relative',
    width: 'fit-content',
    maxWidth: '100%',
    zIndex: 2,
    maxHeight: '200px',
    // Set your desired maximum height here
    overflowY: 'auto' // Enable vertical scrolling
  };
});
var DropdownMenuItem = exports.DropdownMenuItem = (0, _styledComponents["default"])(DropdownMenu.Item).withConfig({
  displayName: "Selectstyle__DropdownMenuItem",
  componentId: "sc-yhisnp-7"
})(function (_ref5) {
  var theme = _ref5.theme;
  return _objectSpread(_objectSpread({
    background: theme.color.neutral['08'],
    textAlign: 'left',
    border: "1px solid ".concat(theme.color.neutral['06']),
    padding: "".concat(theme.spacing.inline['4xs'], " ").concat(theme.spacing.inline['3xs']),
    cursor: 'pointer',
    color: theme.color.neutral['02']
  }, (0, _utils.getTextStyle)({
    theme: theme,
    variant: 'body02-sm',
    margin: false
  })), {}, {
    '&.active': {
      background: theme.color.brandPrimary.medium,
      color: theme.color.neutral['08']
    },
    ':not(.active):hover': {
      background: "".concat(theme.color.brandPrimary.light, "0d")
    },
    ':not(.active):focus-visible': {
      background: "".concat(theme.color.brandPrimary.light, "0d")
    }
  });
});